import * as React from "react";
import { useState, useEffect } from "react";

interface LoadingStatusProps {
  className?: string;
  status: string;
  text: string[];
}

const LoadingStatus = ({ status, text, className }: LoadingStatusProps) => {
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      let newIndex = currentTextIndex;
      while (newIndex === currentTextIndex && text.length > 1) {
        newIndex = Math.floor(Math.random() * text.length);
      }
      setCurrentTextIndex(newIndex);
    }, 4000);

    return () => clearInterval(interval);
  }, [currentTextIndex, text]);

  return (
    <div
      className={`${className} fixed top-0 left-0 w-full h-[100vh] z-[100] flex justify-center items-center overflow-hidden`}
    >
      <div className="flex flex-col gap-[30px] max-w-[430px] px-[30px] items-center justify-center">
        <img
          className="w-[77px] h-[77px]"
          src="/assets/loading-avatar.gif"
          alt="loading"
        />
        <span className="text-[24px] text-center">
          {text[currentTextIndex]}
        </span>
      </div>
    </div>
  );
};

export default LoadingStatus;
